import { ReactComponent as DesignRequestIcon } from '@apparel/ui/icons/designRequestIcon.svg';
import { ReactComponent as RedoRequestIcon } from '@apparel/ui/icons/redoRequestIcon.svg';
import { ReactComponent as LogoRedrawIcon } from '@apparel/ui/icons/redrawIcon.svg';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import ChatOutlinedIcon from '@material-ui/icons/ChatOutlined';
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';

export const CATEGORY_TYPES = [
    { id: 1, bgColor: '#7E58CE', icon: ReceiptOutlinedIcon },
    { id: 2, bgColor: '#D99843', icon: DesignRequestIcon },
    { id: 3, bgColor: '#B347A8', icon: ChatOutlinedIcon },
    { id: 4, bgColor: '#5047B3', icon: ChatOutlinedIcon },
    { id: 5, bgColor: '#A0A243', icon: RedoRequestIcon },
    { id: 6, bgColor: '#7AB95C', icon: AccountCircleOutlinedIcon },
    { id: 7, bgColor: '#BF5656', icon: AssessmentOutlinedIcon },
    { id: 8, bgColor: '#3D9A95', icon: PrintOutlinedIcon },
    { id: 9, bgColor: '#376BA', icon: LogoRedrawIcon },
];

export const CATEGORY = {
    ALL_CATEGORY: 0,
};
